export const newsTags = ['市场分析', '投资策略', '政策法规', '热点解读'];

export const carouselItems = [
  {
    id: 'c-001',
    title: '伦敦金现站上 2400 美元关口',
    desc: '避险情绪与降息预期双重发力，国际金价周涨幅创近三个月新高，机构资金持续回流贵金属。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20golden%20waves%20and%20glowing%20particles%20flowing%20over%20a%20deep%20navy%20gradient%20background%2C%20luxurious%20wealth%20and%20finance%20concept%2C%20soft%20warm%20gold%20highlights%2C%20elegant%20editorial%20composition&width=1280&height=640&seq=gold-hero-001&orientation=landscape',
    tag: '行情快讯',
    date: '2026-10-12',
    link: '/detail/price/p-xauusd',
  },
  {
    id: 'c-002',
    title: '美联储议息会议前瞻：三大情景推演',
    desc: '点阵图与声明措辞将成为左右金价的关键变量，本文梳理偏鸽、中性、偏鹰三种情景下的黄金可能表现。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20golden%20candlestick%20chart%20rising%20across%20a%20dark%20navy%20backdrop%20with%20soft%20glowing%20grid%20lines%2C%20financial%20market%20analysis%20concept%2C%20minimal%20professional%20lighting&width=1280&height=640&seq=gold-hero-002&orientation=landscape',
    tag: '市场分析',
    date: '2026-10-11',
    link: '/detail/news/n-002',
  },
  {
    id: 'c-003',
    title: '全球央行连续增持黄金储备',
    desc: '新兴市场国家成为主要买家，储备资产多元化成为长期支撑金价的结构性力量。',
    image:
      'https://readdy.ai/api/search-image?query=Rows%20of%20gleaming%20gold%20bullion%20bars%20in%20a%20secure%20vault%20with%20warm%20golden%20lighting%20and%20deep%20navy%20shadows%2C%20institutional%20reserve%20concept%2C%20symmetrical%20elegant%20composition&width=1280&height=640&seq=gold-hero-003&orientation=landscape',
    tag: '政策法规',
    date: '2026-10-09',
    link: '/detail/news/n-004',
  },
  {
    id: 'c-004',
    title: '黄金投资入门专题上线',
    desc: '实物金条、黄金ETF、纸黄金、期货、黄金股票，五种主流配置方式全景解析，助你迈出第一步。',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20gold%20coins%20and%20gold%20bars%20on%20a%20warm%20ivory%20surface%20with%20soft%20luxury%20lighting%2C%20investment%20guide%20concept%2C%20refined%20editorial%20still%20life&width=1280&height=640&seq=gold-hero-004&orientation=landscape',
    tag: '专题推荐',
    date: '2026-10-10',
    link: '/category/investment-news',
  },
];

export const topics = [
  {
    id: 't-001',
    title: '黄金投资入门',
    desc: '从零开始认识黄金，搞懂实物金、ETF、期货的区别与选择逻辑。',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20still%20life%20of%20a%20single%20gold%20coin%20resting%20on%20a%20clean%20warm%20ivory%20surface%20with%20soft%20natural%20light%2C%20beginner%20investing%20concept%2C%20calm%20elegant%20composition&width=600&height=400&seq=gold-topic-001&orientation=landscape',
    count: '12 篇文章',
    link: '/category/investment-news',
  },
  {
    id: 't-002',
    title: '市场回顾',
    desc: '每周梳理黄金市场关键数据与价格脉络，把握行情演变的节奏。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20weekly%20golden%20price%20chart%20with%20soft%20glow%20on%20a%20light%20neutral%20background%2C%20market%20review%20concept%2C%20minimal%20data%20visualization%20aesthetic&width=600&height=400&seq=gold-topic-002&orientation=landscape',
    count: '8 篇文章',
    link: '/category/gold-price',
  },
  {
    id: 't-003',
    title: '地缘政治与金价',
    desc: '解读突发事件如何影响避险需求，历史地缘行情规律全复盘。',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20golden%20light%20rays%20through%20dark%20navy%20clouds%20symbolizing%20geopolitical%20risk%20and%20safe%20haven%20demand%2C%20cinematic%20moody%20atmosphere&width=600&height=400&seq=gold-topic-003&orientation=landscape',
    count: '6 篇文章',
    link: '/category/investment-news',
  },
  {
    id: 't-004',
    title: '央行购金观察',
    desc: '追踪全球央行黄金储备变化，理解储备多元化背后的长期逻辑。',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20stacked%20gold%20bars%20with%20soft%20warm%20reflections%20on%20a%20clean%20neutral%20background%2C%20central%20bank%20reserve%20concept%2C%20refined%20macro%20photography&width=600&height=400&seq=gold-topic-004&orientation=landscape',
    count: '5 篇文章',
    link: '/category/investment-news',
  },
];

export const hotKeywords = ['黄金价格', '现货黄金', '黄金ETF', '央行购金', '美联储降息', '黄金期货'];